import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { withViewport } from '../../util/uiHelpers';
import { useConfiguration } from '../../context/configurationContext';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import css from './FAQPage.module.css';

//Static assets
import facebookImage from '../../assets/biketribe-facebook-sharing-1200x630.jpg';
import twitterImage from '../../assets/biketribe-twitter-sharing-600x314.jpg';
import FAQSection from './FAQSection';
import SectionGetInTouch from './SectionGetInTouch';

export const FAQPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  const config = useConfiguration();
  const marketplaceName = config.marketplaceName;

  const schemaTitle = intl.formatMessage({ id: 'FAQPage.schemaTitle' }, { marketplaceName });
  const schemaDescription = intl.formatMessage({ id: 'FAQPage.schemaDescription' });
  const schemaImage = `${config.marketplaceRootURL}${facebookImage}`;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        {
          url: `${config.marketplaceRootURL}${twitterImage}`,
          width: 600,
          height: 314,
        },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.pageContent}>
          <div className={css.faqHead}>
            {/* <span>Support</span> */}
            <h1>FAQ (Frequently Asked Questions)</h1>
            {/* <p>
              Last updated: February 12, 2026. If anything here conflicts with our Terms of Service,
              the Terms control.
            </p> */}
          </div>
          <FAQSection />
          <SectionGetInTouch />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

FAQPageComponent.propTypes = {
  scrollingDisabled: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

FAQPageComponent.defaultProps = {};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const FAQPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    null
  ),
  withViewport,
  injectIntl
)(FAQPageComponent);

export default FAQPage;
